// extracted by mini-css-extract-plugin
export default {"modal":"FatalPay_modal__66-cA","title":"FatalPay_title__fgbS-","fatal":"FatalPay_fatal__H+2E4","float":"FatalPay_float__vXU2T"};